import Nationality, { type NationalityFieldProps } from '../../../components/fields/NationalityField';
import SelectField from './SelectField';

const NationalityField = (props: NationalityFieldProps) => <Nationality SelectComp={SelectField} {...props} />;

export default NationalityField;
